<template>
  <div>
    <h1>404 Not Found</h1>
    <p>The page you're looking for doesn't exist.</p>
  </div>
</template>

<script>
export default {
  name: "NotFound",
};
</script>
